import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";

const isNoRowSelected = (checkedItems: number[]): boolean =>
  checkedItems.length === 0;

const LmsAccountingNetSuitJeMainPage  = () => {

  const handleVoid = (selectedIds) => {
    return selectedIds;
  };

  const handleApproveJe = (selectedIds) => {
    return selectedIds;
  };

  const actionButtons = [
    "export",
    {
      action: "submitselected",
      text: "Void",
      submitSuffix: "/netsuiteje/void-jes",
      method: "PUT", 
      icon: GlobalConstants.Icons.ARCHIVE,
      data: handleVoid,
      refreshDataOnSuccess: true,
      isDisabled: isNoRowSelected
    },
    {
      action: "submitselected",
      text: "Approve JE",
      submitSuffix: "/netsuiteje/approve-jes",
      method: "PUT", 
      icon: GlobalConstants.Icons.ARCHIVE,
      data: handleApproveJe,
      refreshDataOnSuccess: true,
      isDisabled: isNoRowSelected
    },

  ];

  return (
    <LmsTable
    actionButtons={actionButtons as any}
    apiSuffix="netsuiteje/info-list" 
    skipClick
    />
  );
};

const LmsAccountingNetSuitJe = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <LmsAccountingNetSuitJeMainPage />;
};

export default LmsAccountingNetSuitJe;
